var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMembershipPlanTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.405 5.42444C12.7961 5.42444 13.1131 5.74142 13.1131 6.13244V14.6283C13.1131 15.0193 12.7961 15.3363 12.405 15.3363H3.90917C3.51816 15.3363 3.20117 15.0193 3.20117 14.6283V6.13244C3.20117 5.74136 3.51809 5.42437 3.90917 5.42444H12.405Z",
    fill: "#C1F700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6515 1.52979L7.80162 12.5037L4.26172 8.96374",
    stroke: "white",
    strokeWidth: 0.738892,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.527 8.60991V16.0438C14.527 16.4348 14.2101 16.7518 13.819 16.7518H2.49121C2.10019 16.7518 1.7832 16.4348 1.7832 16.0438V4.71593C1.7832 4.32492 2.10019 4.00793 2.49121 4.00793H10.6331",
    stroke: "white",
    strokeWidth: 0.738892,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembershipPlanTickIcon);
export default __webpack_public_path__ + "static/media/membership-plan-tick-icon.6a50ffa1d506e075286c46469ca21133.svg";
export { ForwardRef as ReactComponent };